<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  @import "./assets/icons/style.css";
  @import "../node_modules/animate.css/animate.css";
</style>



// WEBPACK FOOTER //
// src/App.vue